import { FieldBase } from '@/components/form';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import { Toggle } from '@e2n/ui';
import { useTranslation } from 'react-i18next';

type StundenbewertungToggleProps = {
  onlyFesteStundenbewertung: boolean;
};

export function StundenbewertungToggle({
  onlyFesteStundenbewertung,
}: StundenbewertungToggleProps) {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const { ctx } = useAnlageassistentContext();

  return (
    <form.AppField
      name="abwesenheiten.allgemein.stundenBewertung"
      defaultValue={onlyFesteStundenbewertung ? 'fest' : undefined}
      listeners={{
        onChange: () => {
          ctx.resetDependentFields('abwesenheiten.allgemein.stundenBewertung');
        },
      }}>
      {(field) => (
        <FieldBase>
          <div className="grid md:grid-cols-2 gap-4">
            <Toggle
              value="fest"
              onPressedChange={() => field.handleChange('fest')}
              pressed={field.state.value === 'fest'}
              variant={'outline'}
              className="flex items-center justify-start gap-2 p-4 h-auto">
              {t(
                'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.stundenbewertung.options.fest',
              )}
            </Toggle>
            <Toggle
              value="dynamisch"
              onPressedChange={() => field.handleChange('dynamisch')}
              pressed={field.state.value === 'dynamisch'}
              variant={'outline'}
              className="flex items-center justify-start gap-2 p-4 h-auto">
              {t(
                'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.stundenbewertung.options.dynamisch',
              )}
            </Toggle>
          </div>
        </FieldBase>
      )}
    </form.AppField>
  );
}
